const translationService = {
  changeLanguage: (language: string) => {
    // Stub implementation for translation service
    console.log(`Changed language to: ${language}`);
  },
};

export default translationService;
